
import { mapGetters } from 'vuex'
import ReviewStars from './review-stars.vue'
export default {
  components: { ReviewStars },
  inject: ['wording'],
  props: {
    review: {
      type: Object,
      required: true,
    },
    voteDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      wording: this.wording,
      customFields: {
        productSize: null,
        usualSize: null,
        customerHeight: null,
      },
      reviewId: this.review.id,
      reviewVoteType: null,
      upVotes: this.review.votes_up,
      downVotes: this.review.votes_down,
    }
  },
  computed: {
    ...mapGetters({
      vxCurrency: 'currency/getCurrency',
    }),
    niceDate() {
      const date = new Date(this.review.date)
      const options = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      }

      const localeDate = date.toLocaleDateString('en-US', options)
      return localeDate.toLowerCase() === 'invalid date' ? '' : localeDate
    },
  },
  mounted() {
    this.parseCustomFields()
  },
  methods: {
    parseCustomFields() {
      const cf = this.review.optionsList
      if (!cf) return

      this.customFields.productSize =
        cf.find((field) => field.message === 'product_size')?.value || null
      this.customFields.usualSize =
        cf.find((field) => field.message === 'usual_size')?.value || null
      this.customFields.customerHeight =
        cf.find((field) => field.message === 'customer_height')?.value || null
    },
  },
}
